import React from 'react';
import { Link } from 'react-router-dom';

import styled, { useTheme } from 'styled-components';

import { LogoIcon, LogoIconVariant } from '../Icons';
import LoginIcon from '../Icons/components/affiliate/LoginIcon';
import LogoutIcon from '../Icons/components/affiliate/LogoutIcon';

type User = {
  name: string;
};

type Props = {
  domain?: 'affiliate';
  isLogin?: boolean;
  onLogin?: () => void;
  onLogout?: () => void;
  onCreateAccount?: () => void;
};

const Header = ({ domain, isLogin, onLogin, onLogout, onCreateAccount }: Props) => {
  const theme = useTheme();

  const handleLogin = () => {
    onLogin?.();
  };

  const handleLogout = () => {
    onLogout?.();
  };

  return (
    <SWrapper>
      <nav>
        <Link to={'/dashboard'}>
          <LogoIcon
            width={160}
            height={28}
            variant={LogoIconVariant.BUBBLECHAT}
            className="logo"
            color={theme.color.icon.icon_4}
            style={{ display: 'inline-block' }}
          />
        </Link>
        {/* <ul></ul> */}
      </nav>
      {isLogin ? (
        <SButton onClick={handleLogout}>
          <LogoutIcon />
        </SButton>
      ) : (
        <SButton onClick={handleLogin}>
          <LoginIcon />
        </SButton>
      )}
    </SWrapper>
  );
};

export default Header;

const SWrapper = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: space-between;

  nav {
    display: flex;
    align-items: center;
    gap: 40px;

    .logo {
      height: 28px;
    }
  }
`;

const SButton = styled.button`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  background: ${({ theme }) => theme.color.buttons.default};
`;
